import React, { createContext, useContext, useMemo } from 'react';
import { createServices, Services } from '../services';

// Create a context for our services
const ServiceContext = createContext<Services | null>(null);

// Create a provider component
interface ServiceProviderProps {
  children: React.ReactNode;
}

export const ServiceProvider: React.FC<ServiceProviderProps> = ({ children }) => {
  const services = useMemo(() => createServices(), []);
  
  return (
    <ServiceContext.Provider value={services}>
      {children}
    </ServiceContext.Provider>
  );
};

/**
 * The services around it with some replaced, for a subtree that must not reach the backend: the design system's upload
 * examples keep their files in the browser. `overrides` should be stable (made once, outside render).
 */
export const ServicesOverride: React.FC<{ overrides: Partial<Services>; children: React.ReactNode }> = ({ overrides, children }) => {
  const services = useServices();
  const value = useMemo(() => ({ ...services, ...overrides }), [services, overrides]);
  return <ServiceContext.Provider value={value}>{children}</ServiceContext.Provider>;
};

// Create a hook to use the services
export const useServices = () => {
  const context = useContext(ServiceContext);
  if (!context) {
    throw new Error('useServices must be used within a ServiceProvider');
  }
  return context;
}; 